import type * as Types from '../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ContactNameAffixSuggestionsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  contactCollectionId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;

export type ContactNameAffixSuggestionsQuery = {
  __typename?: 'Query';
  contactNameAffixSuggestions: { __typename?: 'ContactNameAffixSuggestions'; locale: string; prefixes: Array<string>; suffixes: Array<string> };
};

export const ContactNameAffixSuggestionsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ContactNameAffixSuggestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactCollectionId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactNameAffixSuggestions' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'contactCollectionId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'contactCollectionId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefixes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suffixes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useContactNameAffixSuggestionsQuery__
 *
 * To run a query within a React component, call `useContactNameAffixSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactNameAffixSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactNameAffixSuggestionsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      contactCollectionId: // value for 'contactCollectionId'
 *   },
 * });
 */
export function useContactNameAffixSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ContactNameAffixSuggestionsQuery, ContactNameAffixSuggestionsQueryVariables>) {
  return ApolloReactHooks.useQuery<ContactNameAffixSuggestionsQuery, ContactNameAffixSuggestionsQueryVariables>(ContactNameAffixSuggestionsDocument, baseOptions);
}
export function useContactNameAffixSuggestionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContactNameAffixSuggestionsQuery, ContactNameAffixSuggestionsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<ContactNameAffixSuggestionsQuery, ContactNameAffixSuggestionsQueryVariables>(ContactNameAffixSuggestionsDocument, baseOptions);
}
export type ContactNameAffixSuggestionsQueryHookResult = ReturnType<typeof useContactNameAffixSuggestionsQuery>;
export type ContactNameAffixSuggestionsLazyQueryHookResult = ReturnType<typeof useContactNameAffixSuggestionsLazyQuery>;
export type ContactNameAffixSuggestionsQueryResult = Apollo.QueryResult<ContactNameAffixSuggestionsQuery, ContactNameAffixSuggestionsQueryVariables>;
